export class PaginationDM {
  constructor({ count = 0, next = -1, previous = -1, results = [] }) {
    this.count = count;
    this.next = next;
    this.previous = previous;
    this.results = results;
  }

  static fromJson(data) {
    return new PaginationDM({
      count: data["count"],
      next: data["next"],
      previous: data["previous"],
      results: data["results"],
    });
  }
}
